<template>
	<login-to-see-more v-if="userStore.user.privacy_events !== PrivacyType.Public && !$auth.loggedIn" xs-tile sm-tile/>
	<event-assignments-list v-else :url="`/v1/views/users/${userStore.user.id}/results`"
							ref="listComponent"
							   :filter="filterData" searchable
							   :missing-text="t('missing.user.events.past', {user: userStore.user.greeting_name})">
		<template #assignment_skeletons>
			<participation-preview-skeleton with-ranks />
		</template>

		<template #default>
			<client-only>
				<template v-if="userStore.authPermissions.can_edit">
					<container-fab-btn :hide-on-scroll="!$device.isDesktop">
						<btn :title="t('action.add_participation')"
							 color="success"
							 shadow
							 rounded-large
							 @click="showAddParticipationModal = true">
							<icon :icon="icons.create"/>
							<span>{{ t('action.add') }}</span>
						</btn>
					</container-fab-btn>

					<add-manual-participation-modal v-model="showAddParticipationModal"
													:user-key="userStore.user.id"
													:user-display-name="userStore.user.display_name"
													:data="{club_id: userStore.user.club?.id}"
													@success="handleAddedParticipation"/>
				</template>
			</client-only>
		</template>
	</event-assignments-list>
</template>

<script setup lang="ts">
import {useUserStore} from "../../../store/user";
import {PrivacyType} from "@spoferan/spoferan-ts-core";
import {createIcon} from "@spoferan/nuxt-spoferan/icons";

const userStore = useUserStore();
const {t} = useI18n();
const route = useRoute();

if (![PrivacyType.Public, PrivacyType.Community].includes(userStore.user.privacy_events)) {
	throw createError({statusCode: 404, message: t('error.404.message')})
}

const icons = {
	create: createIcon
};

const filterData = ref({
	search: route.query.search,
});

const listComponent = ref(null);
const showAddParticipationModal = ref(false);

async function handleAddedParticipation() {
	listComponent.value.refresh();
}

useMeta({
	title: userStore.buildPageTitle(t('view.users.results.index.title', {user: userStore.user.display_name})),
	description: t('view.users.results.index.description', {user: userStore.user.display_name}),
})

</script>

